import React, { useState } from 'react';
import { FiEdit, FiChevronDown, FiChevronUp } from 'react-icons/fi';

const SectionCard = ({ title, editKey, onEdit, children, loading, collapsible = true, isOpen, toggleOpen,isRequired }) => {
  return (
    <div className="bg-white p-4 sm:p-6 rounded-2xl shadow-sm mt-3 border border-gray-100">
      <div className="flex justify-between items-start sm:items-center gap-2">
        <h3 className="text-sm font-bold text-gray-333">{title}{isRequired&&(<span className="text-red-500 text-lg">*</span>)}</h3> 

        <div className="flex items-center gap-2">
          {isOpen && title !== 'Resume' && (
            loading ? (
              <svg className="animate-spin h-4 w-4 text-gray-400 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
            ) : (
              <button
                onClick={(e) => { e.stopPropagation(); onEdit(editKey); }}
                className="text-gray-500 hover:text-amber-600"
                title={`Edit ${title}`}
                aria-label={`Edit ${title}`}
              >
                <FiEdit size={14} />
              </button>
            )
          )}

          {collapsible && (
            <button
              onClick={toggleOpen}
              className="text-gray-400 hover:text-gray-600"
              aria-label={isOpen ? 'Collapse section' : 'Expand section'}
              title={isOpen ? 'Collapse section' : 'Expand section'}
            >
              {isOpen ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
            </button>
          )}
        </div>
      </div>

      {isOpen && <div className="mt-4">{children}</div>}
    </div>
  );
};
export default SectionCard;